const eCardsFrontVariantsSrcMap = {
  beach: 'common/card-art/beach.jpg',
  blueacrylic: 'common/card-art/blueacrylic.jpg',
  bluecontour: 'common/card-art/bluecontour.jpg',
  blushchiffon: 'common/card-art/blushchiffon.jpg',
  bohemianeucalyptus: 'common/card-art/bohemianeucalyptus.jpg',
  botanicalfun: 'common/card-art/botanicalfun.jpg',
  ceruleanblue: 'common/card-art/ceruleanblue.jpg',
  classicalpeonies: 'common/card-art/classicalpeonies.jpg',
  cobaltgalze: 'common/card-art/cobaltgalze.jpg',
  delicatelavender: 'common/card-art/delicatelavender.jpg',
  desertdaydream: 'common/card-art/desertdaydream.jpg',
  elegantflowers: 'common/card-art/elegantflowers.jpg',
  eucalyptus: 'common/card-art/eucalyptus.jpg',
  gardenestate: 'common/card-art/gardenestate.jpg',
  goldengarden: 'common/card-art/goldengarden.jpg',
  goldenhaze: 'common/card-art/goldenhaze.jpg',
  goldfoil: 'common/card-art/goldfoil.jpg',
  graphiteblooms: 'common/card-art/graphiteblooms.jpg',
  ivorygarden: 'common/card-art/ivorygarden.jpg',
  jellies: 'common/card-art/jellies.jpg',
  kingprotea: 'common/card-art/kingprotea.jpg',
  labutte: 'common/card-art/labutte.jpg',
  leaves: 'common/card-art/leaves.jpg',
  lemonsflowers: 'common/card-art/lemonsflowers.jpg',
  modernsimplicty: 'common/card-art/modernsimplicty.jpg',
  modshapestropical: 'common/card-art/modshapestropical.jpg',
  monowreath: 'common/card-art/monowreath.jpg',
  mountaingetaway: 'common/card-art/mountaingetaway.jpg',
  multicoloredblocks: 'common/card-art/multicoloredblocks.jpg',
  naturalgreenery: 'common/card-art/naturalgreenery.jpg',
  neapolitan: 'common/card-art/neapolitan.jpg',
  pacificnorthwest: 'common/card-art/pacificnorthwest.jpg',
  peonieswoodcut: 'common/card-art/peonieswoodcut.jpg',
  romanticfloral: 'common/card-art/romanticfloral.jpg',
  rosey: 'common/card-art/rosey.jpg',
  strunginlove: 'common/card-art/strunginlove.jpg',
  succulentsunset: 'common/card-art/succulentsunset.jpg',
  tropicalbotanical: 'common/card-art/tropicalbotanical.jpg',
  vibrantcrown: 'common/card-art/vibrantcrown.jpg',
  whitegarden: 'common/card-art/whitegarden.jpg',
  wonderferris: 'common/card-art/wonderferris.jpg',
} as const;
export type ECardsFrontVariant = keyof typeof eCardsFrontVariantsSrcMap;
type ECardType = 'invite' | 'std';
export const getECardSrc = (variant: ECardsFrontVariant) => {
  return eCardsFrontVariantsSrcMap[variant];
};

export const getECardCopySrc = (variant: number, cardType: ECardType) => {
  return cardType === 'std' ? `common/save-the-date-text/std-${variant}.svg` : `common/invite-text/invitation-${variant}.svg`;
};
